@if (typeForced === 'LIST_REF' && loading) {
	<lbca-list-reference [options]="options"
		[label]="field.label"
		[field]="field"
		[value]="valueInput"
	 />
}

@if (typeForced === 'SELECT_ONE' && loading) {
	<lbca-select [label]="field.label"
		[keySort]="field.keySort"
		[tabeled]="isTabeled"
		[options]="options"
		[disabled]="isDisabled"
		[labeled]="isLabeled"
		[editable]="isEditable"
		[require]="field.required"
		[loading]="loadingAnimation"
		[error]="error"
		(errorState)="setError($event)"
		(focusState)="focusState($event)"
		(changeLabelValue)="changeLabelValue($event)"
		(changeValue)="changeValue($event)"
		[value]="valueInput"
		[removeItens]="excludeItens"
		[initialValue]="setInitialValue"
		[helperText]="field.helperText"
	 />
}

@if (typeForced === 'SELECT_ONE_CONDENSED' && loading) {
	<lbca-select-condensed [label]="field.label"
		[tabeled]="isTabeled"
		[options]="options"
		[disabled]="isDisabled"
		[labeled]="isLabeled"
		[editable]="isEditable"
		[require]="field.required"
		[error]="error"
		(errorState)="setError($event)"
		(focusState)="focusState($event)"
		(validState)="setValidControllEmmiter($event)"
		(changeLabelValue)="changeLabelValue($event)"
		(changeValue)="changeValue($event)"
		[value]="valueInput"
		[helperText]="field.helperText"
	 />
}

@if (typeForced === 'RADIO' && loading) {
	<lbca-input-radio [label]="field.label"
		[inline]="isInline"
		[error]="error"
		[options]="options"
		[disabled]="isDisabled"
		[readOnly]="isReadOnly"
		[require]="field.required"
		(changeLabelValue)="changeLabelValue($event)"
		(changeValue)="changeValue($event)"
		(focusState)="focusState($event)"
		(validState)="setValidControllEmmiter($event)"
		(setError)="setError($event)"
		[helperText]="field.helperText"
		[fieldMetadata]="field"
		[value]="valueInput"
	 />
}

@if (field.type === 'SELECT_ONE' && loading && !typeForced) {
	@if (options.length > 4) {
		<lbca-select [label]="field.label"
			[options]="options"
			[disabled]="isDisabled"
			[labeled]="isLabeled"
			[editable]="isEditable"
			[require]="field.required"
			[error]="error"
			(errorState)="setError($event)"
			(changeLabelValue)="changeLabelValue($event)"
			(changeValue)="changeValue($event)"
			(focusState)="focusState($event)"
			(validState)="setValidControllEmmiter($event)"
			[value]="valueInput"
			[initialValue]="setInitialValue"
			[helperText]="field.helperText"
		 />
	}
	@if (4 >= options.length) {
		<lbca-input-radio [label]="field.label"
			[inline]="isInline"
			[error]="error"
			[options]="options"
			[disabled]="isDisabled"
			[readOnly]="isReadOnly"
			[require]="field.required"
			(changeLabelValue)="changeLabelValue($event)"
			(changeValue)="changeValue($event)"
			(startValue)="startValue($event)"
			(focusState)="focusState($event)"
			(validState)="setValidControllEmmiter($event)"
			(setError)="setError($event)"
			[helperText]="field.helperText"
			[fieldMetadata]="field"
			[value]="valueInput"
			[autoSelect]="field.autoSelect"
		 />
	}
}

@if (field.type === 'SELECT_LIST' && loading) {
	@if (4 >= options.length) {
		<lbca-input-checkbox [label]="field.label"
			[options]="options"
			[overlayposition]="'corner-top'"
			[disabled]="isDisabled"
			[require]="field.required"
			[error]="error"
			(focusState)="focusState($event)"
			(validState)="setValidControllEmmiter($event)"
			(changeLabelValue)="changeLabelValue($event)"
			(blurValue)="changeValue($event)"
			[value]="valueInput"
		 />
	}
}

@if ((field.type === 'TABLE_SELECT_ONE' || field.type === 'TABLE_SELECT_LIST') && loading) {
	<lbca-table-field [data]="options"
		[disabled]="isDisabled"
		[isSearch]="isSearch"
		[cardData]="cardInfo"
		[field]="field"
		[error]="error"
		(feedback)="setFeedbackEmmiter($event)"
		[totalPages]="totalPages"
		(selectedValues)="selectedValuesWhitExclusion($event)"
		(focusState)="focusState($event)"
		(searchValue)="searchValue($event)"
		(setError)="setError($event)"
		(selectedPage)="selectedPage($event)"
		[tagList]="searchFilter"
		[value]="valueInput"
	 />
}
